"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpAssessmentAnalysis = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var react_i18next_1 = require("react-i18next");
var DpSectionCard_1 = require("../../Cards/DpSectionCard");
var chartTypes_enum_1 = require("../../Charts/chartTypes.enum");
var models_1 = require("../../../../api/models");
var helpers_1 = require("../../../../api/helpers");
var assessment_type_enum_1 = require("../../../../api/constants/assessment-type.enum");
var DpItemAnalysisChart_1 = require("../../ItemAnalysisChart/DpItemAnalysisChart");
var DpAssessmentAnalysisHeader_1 = __importDefault(require("./DpAssessmentAnalysisHeader"));
var DpAssessmentAnalysis_styled_1 = require("./DpAssessmentAnalysis.styled");
var DpAssessmentAnalysis = function (_a) {
    var assessment = _a.assessment, overallPerformance = _a.overallPerformance, _b = _a.type, type = _b === void 0 ? assessment_type_enum_1.AssessmentType.Assessment : _b, scoringType = _a.scoringType, openItemAnalysisModal = _a.openItemAnalysisModal;
    // ----------- State
    var _c = (0, react_1.useState)(false), initialized = _c[0], setInitialized = _c[1];
    var _d = (0, react_1.useState)([]), formattedData = _d[0], setFormattedData = _d[1];
    // ----------- Const
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var assessmentTemplate = assessment.assessmentTemplate;
    var header = ((0, jsx_runtime_1.jsx)(DpAssessmentAnalysisHeader_1.default, { type: type, scoringType: scoringType, openItemAnalysisModal: openItemAnalysisModal, assessment: assessment }));
    var customOptions = {
        maintainAspectRatio: false,
        scales: {
            xAxes: [
                {
                    ticks: {
                        callback: function (value) { return value; },
                    },
                },
            ],
        },
    };
    var itemsFromAssessment = (0, react_1.useMemo)(function () { return models_1.AssessmentTemplate.findCoreItems([assessmentTemplate]); }, [assessmentTemplate]);
    // ----------- Methods
    var getWordsHeaders = (0, react_1.useMemo)(function () {
        var wordsCount = assessmentTemplate.items[0].maxScore;
        var wordsHeaders = [];
        for (var i = 0; i < wordsCount; i++) {
            wordsHeaders.push("".concat(t('assessmentAnalysis.word'), " ").concat((i + 1).toString()));
        }
        return wordsHeaders;
    }, [assessmentTemplate, t]);
    var parseReportData = (0, react_1.useCallback)(function (questionsPerformance, wordsPerformance) { return __awaiter(void 0, void 0, void 0, function () {
        var headers_1, performances, reportData;
        return __generator(this, function (_a) {
            if (!(0, isEmpty_1.default)(questionsPerformance) || !(0, isEmpty_1.default)(wordsPerformance)) {
                performances = void 0;
                if (type === assessment_type_enum_1.AssessmentType.Vocabulary) {
                    headers_1 = getWordsHeaders;
                    performances = wordsPerformance;
                }
                else {
                    headers_1 = (0, helpers_1.getItemPartsLabels)(questionsPerformance, itemsFromAssessment);
                    performances = questionsPerformance;
                }
                reportData = performances.map(function (item, index) { return ({
                    label: headers_1[index],
                    percentage: item.percentage,
                }); });
                setFormattedData(reportData);
                setInitialized(true);
            }
            return [2 /*return*/];
        });
    }); }, [itemsFromAssessment, getWordsHeaders, type]);
    (0, react_1.useEffect)(function () {
        if (!(0, isEmpty_1.default)(overallPerformance)) {
            parseReportData(overallPerformance.itemQuestionsPerformance, overallPerformance.itemWordsPerformance);
        }
    }, [overallPerformance, parseReportData]);
    // ----------- Render
    return (initialized && ((0, jsx_runtime_1.jsx)(DpAssessmentAnalysis_styled_1.StyledAssessmentAnalysis, { "data-testid": "assessment-analysis", children: (0, jsx_runtime_1.jsx)(DpSectionCard_1.DpSectionCard, { title: header, children: (0, jsx_runtime_1.jsx)("div", { className: "report", children: (0, jsx_runtime_1.jsx)(DpItemAnalysisChart_1.DpItemAnalysisChart, { id: "assessmentAnalysis_".concat(assessment.id), ariaLabel: t('assessmentAnalysis.ariaLabel', {
                        title: assessment.assessmentTemplate.title,
                    }), type: chartTypes_enum_1.LibraryChartTypes.Bar, options: customOptions, items: formattedData }) }) }) })));
};
exports.DpAssessmentAnalysis = DpAssessmentAnalysis;
exports.default = exports.DpAssessmentAnalysis;
